import api from './api';
import { Zeiteintrag, ZeiteintragCreate, ZeiteintragZusammenfassung } from '../types';

interface ZeiteintragListParams {
  projekt_id?: number;
  mitarbeiter_id?: number;
  audit_id?: number;
  datum_von?: string;
  datum_bis?: string;
  rechnung_id?: number;
  abgerechnet?: boolean;
  nur_nicht_abgerechnet?: boolean;
}

const zeiteintraegeService = {
  list: async (params?: ZeiteintragListParams): Promise<Zeiteintrag[]> => {
    const response = await api.get('/zeiteintraege/', { params });
    return response.data;
  },

  get: async (id: number): Promise<Zeiteintrag> => {
    const response = await api.get(`/zeiteintraege/${id}`);
    return response.data;
  },

  create: async (data: ZeiteintragCreate): Promise<Zeiteintrag> => {
    const response = await api.post('/zeiteintraege/', data);
    return response.data;
  },

  update: async (id: number, data: Partial<ZeiteintragCreate>): Promise<Zeiteintrag> => {
    const response = await api.put(`/zeiteintraege/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/zeiteintraege/${id}`);
  },

  loeseAbrechnung: async (id: number): Promise<Zeiteintrag> => {
    const response = await api.put(`/zeiteintraege/${id}`, { rechnung_id: null });
    return response.data;
  },

  zusammenfassung: async (params?: { projekt_id?: number; datum_von?: string; datum_bis?: string }): Promise<ZeiteintragZusammenfassung[]> => {
    const response = await api.get('/zeiteintraege/zusammenfassung', { params });
    return response.data;
  },

  downloadZeitnachweis: async (projektId: number, monat: string, template: 'enbw' | 'stark' = 'enbw'): Promise<void> => {
    const response = await api.get('/zeiteintraege/zeitnachweis-pdf', {
      params: { projekt_id: projektId, monat, template },
      responseType: 'blob',
    });
    const filename = response.headers['content-disposition']?.match(/filename="?(.+?)"?$/)?.[1] || `zeitnachweis-${projektId}-${monat}-${template}.pdf`;
    const url = URL.createObjectURL(response.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  },
};

export default zeiteintraegeService;
